export default __webpack_public_path__ + "static/media/NewHomeBG.4fdd8417.jpg";